function uiParams() {
    const s = window.getLoomlyAiUiState ? window.getLoomlyAiUiState() : {};
    return { sidebar_expanded: s.sidebar_expanded || false, chat_open: s.open || false, is_side_chat: s.is_side_chat || false };
}

export const sendMessage = (calendarId, { text, conversationId, prevMessageId }) => {
    let aborted = false;
    const xhr = $.ajax({
        url: `/calendars/${calendarId}/chat_messages.json`,
        method: 'POST',
        data: {
            text,
            conversation_id: conversationId,
            prev_message_id: prevMessageId
        }
    });

    const promise = new Promise((resolve, reject) => {
        xhr.done(resolve).fail((jqXHR) => {
            if (aborted) {
                reject(new Error('aborted'));
            } else {
                reject(new Error(jqXHR.responseJSON?.error || 'Request failed'));
            }
        });
    });

    return { promise, abort: () => { aborted = true; xhr.abort(); } };
};

export const getConversations = (calendarId, { currentConversationId } = {}) => {
    return $.get(`/calendars/${calendarId}/conversations.json`, {
        current_conversation_id: currentConversationId,
        ...uiParams()
    });
};

export const getConversationMessages = (calendarId, conversationId, { fromConversationId } = {}) => {
    return $.get(`/calendars/${calendarId}/conversations/${conversationId}/messages.json`, {
        from_conversation_id: fromConversationId,
        ...uiParams()
    });
};

export const getProcessingStatus = (calendarId, conversationId) => {
    return $.get(`/calendars/${calendarId}/conversations/${conversationId}/processing_status.json`);
};

export const renameConversation = (calendarId, conversationId, title) => {
    return $.ajax({
        url: `/calendars/${calendarId}/conversations/${conversationId}.json`,
        method: 'PATCH',
        data: { title }
    });
};

export const deleteConversation = (calendarId, conversationId) => {
    return $.ajax({
        url: `/calendars/${calendarId}/conversations/${conversationId}.json`,
        method: 'DELETE',
        data: uiParams()
    });
};

export const upvoteMessage = (calendarId, conversationId, messageId, upvoted) => {
    return $.ajax({
        url: `/calendars/${calendarId}/chat_messages/${messageId}/upvote`,
        method: 'PATCH',
        data: { conversation_id: conversationId, upvoted, ...uiParams() }
    });
};

export const submitReview = (calendarId, conversationId, messageId, feedback) => {
    return $.ajax({
        url: `/calendars/${calendarId}/chat_messages/${messageId}/review`,
        method: 'POST',
        data: { conversation_id: conversationId, feedback }
    });
};

export const importMediaFromUrl = (url, calendarId) => {
    return $.ajax({
        url: '/import_media_from_urls.json',
        method: 'POST',
        data: { url, calendar_id: calendarId }
    }).then(response => response.media);
};

export const saveAsIdea = (calendarId, conversationId, messageId) => {
    return $.ajax({
        url: `/calendars/${calendarId}/chat_messages/${conversationId}/save_as_idea/${messageId}`,
        method: 'POST',
        data: uiParams()
    });
};

export const fetchMedia = (type, id) => {
    const route = {
        Photo: '/photos',
        Video: '/videos',
        Document: '/documents',
    }[type];

    if (!route || !id) return Promise.reject(new Error('Invalid media reference'));
    return $.get(`${route}/${id}.json`);
};
